import { string } from 'yup';

import { NAME_REGEX } from '@air/utils-regex';

export const firstNameValidationSchema = string()
  .required('First name is required')
  .matches(NAME_REGEX, 'No special characters allowed');
